'use strict'

import Vue from 'vue'
import * as type from './types'
import actions from './actions'
import getters from './getters'

const state = {
  isFetching: false,
  error: null,
  data: {}
}

const mutations = {
  [type.REQUEST_LIST_VEHICLES] (state) {
    state.isFetching = true
    state.error = null
  },

  [type.REQUEST_LIST_VEHICLES_SUCCESS] (state, action) {
    state.isFetching = false
    // state.data = action.payload;
    state.data = action.payload.reduce(function (acc, cur, i) {
      acc[cur.id] = cur
      return acc
    }, {})
    state.error = null
  },

  [type.REQUEST_LIST_VEHICLES_ERROR] (state, action) {
    state.isFetching = false
    state.error = action.error
  },

  [type.REQUEST_GET_VEHICLE] (state) {
    state.isFetching = true
    state.error = null
  },

  [type.REQUEST_GET_VEHICLE_SUCCESS] (state, action) {
    state.isFetching = false
    Vue.set(state.data, action.payload.id, action.payload)
    state.error = null
  },

  [type.REQUEST_GET_VEHICLE_ERROR] (state, action) {
    state.isFetching = false
    state.error = action.error
  },

  [type.REQUEST_CREATE_VEHICLE] (state) {
    state.isFetching = true
    state.error = null
  },

  [type.REQUEST_CREATE_VEHICLE_SUCCESS] (state, action) {
    state.isFetching = false
    state.data[action.id] = state.data[action.vehicle]
    state.error = null
  },

  [type.REQUEST_CREATE_VEHICLE_ERROR] (state, action) {
    state.isFetching = false
    state.error = action.error
  },

  [type.REQUEST_DELETE_VEHICLE] (state) {
    state.isFetching = true
    state.error = null
  },

  [type.REQUEST_DELETE_VEHICLE_SUCCESS] (state, action) {
    state.isFetching = false
    // delete state.data[action.vehicleID];
    Vue.delete(state.data, action.vehicleID)
    state.error = null
  },

  [type.REQUEST_DELETE_VEHICLE_ERROR] (state, action) {
    state.isFetching = false
    state.error = action.error
  },

  [type.REQUEST_UPDATE_VEHICLE] (state) {
    state.isFetching = true
    state.error = null
  },

  [type.REQUEST_UPDATE_VEHICLE_SUCCESS] (state, action) {
    state.isFetching = false
    state.data[action.id] = state.data[action.vehicle]
    state.error = null
  },

  [type.REQUEST_UPDATE_VEHICLE_ERROR] (state, action) {
    state.isFetching = false
    state.error = action.error
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
